import { RateBreakdownInstructions } from 'src/api/FiretrolApiClient';
import {
  EffectiveRateParams,
  useEffectiveRate,
} from 'src/api/queries/timesheets/useEffectiveRate';
import { getErrorMessage } from 'src/utils';

interface UseEffectiveRatePreviewResult {
  effectiveRate: number | null;
  instructions: RateBreakdownInstructions | null;
  loading: boolean;
  error: string | null;
}

export const useEffectiveRatePreview = (
  params: EffectiveRateParams,
): UseEffectiveRatePreviewResult => {
  const { data, isFetching, error } = useEffectiveRate(params);

  return {
    effectiveRate: data?.calculation.effectiveRate ?? null,
    instructions: data?.instructions ?? null,
    loading: isFetching,
    error: error
      ? getErrorMessage(error, 'Failed to fetch rate preview')
      : null,
  };
};
